import { SpeedDial } from "@mui/material";
import React from "react";
import EditIcon from '@mui/icons-material/Edit';
import TaskFilter from '../components/task-filter'
import TaskItem from '../components/task-item'

const Home = () => {
  return (
    <div>
      <div style={{padding: 32, backgroundColor: '#ffffff', margin: 16, border: '1px solid #e0e0e0', boxShadow: '0px 0px 20px -18px #424242', borderRadius: 5, fontSize: 15 }}>
        Bem vindo ao sistema de gestão de inadimplentes.
      </div>
    </div>
  );
};

export default Home;